import React from "react";
import { Link } from "react-router-dom";
import { useQrCodeModal } from "../../userDashboard/myBooking/QrCodeModalContext";

interface DriverBookingCardProps {
  compraId: number;
  status: string;
  dataReserva: string;
  horaReserva?: string;
  precoTotal: number;
  adultos: number;
  criancas: number;
  quantidadePessoas: number;
  pacote: {
    id: number;
    titulo: string;
    duracaoEmMinutos?: number;
    primeiraFotoId?: number;
  };
  qrCodeMotorista?: string; // QR Code Base64 do motorista
  unreadCount?: number; // 🔹 Novo: mensagens não vistas
}

const DriverBookingCard: React.FC<DriverBookingCardProps> = ({
  compraId,
  status,
  dataReserva,
  horaReserva,
  precoTotal,
  adultos,
  criancas,
  quantidadePessoas,
  pacote,
  qrCodeMotorista,
  unreadCount = 0,
}) => {
  const BASE_URL = process.env.REACT_APP_API_URL;
  const { openModal } = useQrCodeModal();

  const imageUrl = pacote.primeiraFotoId
    ? `${BASE_URL}/uploads/${pacote.primeiraFotoId}`
    : "/assets/img/no-image.jpg";

  return (
    <div className="card mb-3 shadow-sm">
      <div className="row g-0">
        {/* 🔹 Coluna da imagem + QR Code */}
        <div className="col-md-4 d-flex flex-column align-items-center p-2">
          <Link to={`/flight-details/${pacote.id}`}>
            <img
              src={imageUrl}
              alt={pacote.titulo}
              className="img-fluid rounded mb-2"
              style={{ cursor: "pointer" }}
            />
          </Link>

          {qrCodeMotorista && (
            <div className="qr-code mt-2 text-center">
              <img
                src={`data:image/png;base64,${qrCodeMotorista}`}
                alt="QR Code"
                className="img-fluid"
                style={{ maxWidth: "150px" }}
              />
              <p className="small mt-1">QR Code</p>

              <button
                className="btn btn-sm btn-outline-primary mt-2"
                onClick={() =>
                  openModal({
                    base64: qrCodeMotorista,
                    url: `${window.location.origin}/?purchaseId=${compraId}`,
                    compraId: compraId,
                  })
                }
              >
                See purchase details
              </button>
            </div>
          )}
        </div>

        {/* 🔹 Coluna de informações */}
        <div className="col-md-8">
          <div className="card-body d-flex flex-column h-100">
            <h5 className="card-title mb-2">
              <Link
                to={`/flight-details/${pacote.id}`}
                className="text-decoration-none"
                style={{ color: "#0d6efd", transition: "color 0.2s" }}
                onMouseEnter={(e) =>
                  (e.currentTarget.style.color = "#0a58ca")
                }
                onMouseLeave={(e) =>
                  (e.currentTarget.style.color = "#0d6efd")
                }
              >
                {pacote.titulo}
              </Link>
            </h5>

            <p className="card-text">
              <strong>Status:</strong> {status}
            </p>
            <p className="card-text">
              <strong>Date:</strong>{" "}
              {new Date(dataReserva).toLocaleDateString()}{" "}
              {horaReserva ? `- ${horaReserva}` : ""}
            </p>
            {pacote.duracaoEmMinutos && (
              <p className="card-text">
                <strong>Duration:</strong> {pacote.duracaoEmMinutos} min
              </p>
            )}
            <p className="card-text">
              <strong>Passengers:</strong> {quantidadePessoas} ({adultos} adults, {criancas} children)
            </p>

            <p className="card-text text-primary fw-bold">
              Total: € {precoTotal.toFixed(2)}
            </p>

            <div className="d-flex gap-2 mt-auto">
              <Link
                to={`/flight-details/${pacote.id}`}
                className="btn btn-outline-primary btn-sm"
              >
                See Details
              </Link>

              {/* 🔹 Chat vinculado à compra com badge */}
              <Link
                to={`/driver/chat/${compraId}`}
                className="btn btn-outline-primary btn-sm position-relative mt-2"
              >
                Chat
                {unreadCount > 0 && (
                  <span
                    className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger"
                    style={{ fontSize: "0.6rem" }}
                  >
                    {unreadCount}
                  </span>
                )}
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DriverBookingCard;